<script>
/* tools */
import { mapState } from 'vuex';
import { applyLanguage } from '@/scripts/language';
import { rushBalance } from '@/scripts/computed';

export default {
  name: 'Balance',
  props: {},
  data() {
    return {};
  },
  computed: {
    ...mapState(['balances']),
    rushBalance,
    splittedBalance() {
      const { rushBalance = 0 } = this;

      const parsed = parseFloat(rushBalance);
      const formatted = parsed ? parsed.toFixed(2) : '0.00';
      const str = `${formatted}`;
      const [integer = '0', fraction = '00'] = str.split('.');
      const result = { integer, fraction: `.${fraction}` };

      return result;
    },
  },
  created() {},
  mounted() {},
  methods: {
    applyLanguage,
  },
};
</script>

<template>
  <div class="balance-block">
    <div class="balance-block__title">
      {{ applyLanguage('balance', 'Dashboard') }}
    </div>
    <div class="balance-block__value">
      <img :src="require('@/assets/svg/dollar.svg')" />
      <span
        >{{ splittedBalance.integer
        }}<span>{{ splittedBalance.fraction }}</span>
      </span>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.balance-block {
  padding-top: 6px;

  &__title {
    font-family: Poppins-Regular;
    color: rgba(255, 255, 255, 0.4);
    font-size: 12px;
    line-height: 17px;
    margin-bottom: 15px;
    text-transform: capitalize;
    text-align: right;
  }

  &__value {
    display: flex;
    align-items: center;
    font-family: Poppins-Regular;
    font-size: 27px;
    line-height: 30px;
    color: #ffffff;

    img {
      width: 24px;
      height: 24px;
      display: flex;
      margin-right: 12px;
    }

    span span {
      font-size: 21px;
    }
  }
}

@media (max-width: $mobile) {
  .balance-block {
    padding-top: 0;

    &__title {
      margin-bottom: 10px;
    }

    &__value {
      font-size: 18px;
      line-height: 25px;

      img {
        width: 16px;
        height: 16px;
        margin-right: 5px;
      }

      span span {
        font-size: 18px;
      }
    }
  }
}
</style>
